import { AppVersionsResponse } from 'types/analytics.types';
import { apiService } from './apiService';

export interface AppVersionsQuery {
  days?: number;
  targetVersion?: string;
  platform?: 'ios' | 'android';
}

export const getAppVersions = async (
  query: AppVersionsQuery = {},
): Promise<AppVersionsResponse | null> => {
  const params = new URLSearchParams();
  if (query.days !== undefined) {
    params.set('days', String(query.days));
  }
  if (query.targetVersion) {
    params.set('targetVersion', query.targetVersion);
  }
  if (query.platform) {
    params.set('platform', query.platform);
  }

  const qs = params.toString();
  const path = `/admin/analytics/app-versions${qs ? `?${qs}` : ''}`;

  return apiService.get<AppVersionsResponse>(path);
};
